import React from "react";
import { Title, Wrapper } from "../../GlobalStyle";
import { EducationWrapper } from "./Styled";

function Education() {
  return (
    <EducationWrapper id="education">
      <Wrapper>
        <Title>Education</Title>
        <div className="edu-container">
          <p>
            NFT 101 - Introduction to NFTs and the Metaverse
            <ul>
              <li>What Is A Non-Fungible Token(NFTs)</li>
              <li>Different Categories Of An NFT</li>
              <li>What Is The Purpose Of NFT</li>
              <li>Complications In The NFT Space</li>
            </ul>
          </p>
          <p>
            NFT 201 - How to Begin Your NFT Journey
            <ul>
              <li>NFTs on different blockchain</li>
              <li>Setting up and guide for Metamask Wallet</li>
              <li>Navigating and deep dive into Opensea</li>
            </ul>
          </p>
          <p>
            NFT 301 - Trading Strategies and Identifying Scams
            <ul>
              <li>Warnings of NFT trading</li>
              <li>How to identify NFT scams</li>
              <li>How to identify NFT projects with good potential</li>
              <li>Trading strategies and frameworks to win in NFT</li>
            </ul>
          </p>
        </div>
      </Wrapper>
    </EducationWrapper>
  );
}
export default Education;
